// src/config.js
export const BASE_URL = "https://lightslategrey-mole-360881.hostingersite.com";